import { Property } from '../types/property';

const getCoOwnershipText = (property: Property) => {
  if (property.type === 'development') {
    if (property.partialCoOwnershipOnly) {
      return 'Some of these homes are only available to buy through Co-Ownership';
    }

    if (property.coOwnershipOnly) {
      return 'These homes are only available to buy through Co-Ownership';
    }
  }

  if (property.type === 'property' && property.coOwnershipOnly) {
    return 'This home is only available to buy through Co-Ownership';
  }

  return '';
};

export default getCoOwnershipText;
